import React, { Component, FC } from 'react';
import { Redirect, Route, Switch } from 'react-router';

import { useClient } from 'hooks';
import { ErrorPage } from 'components';
import { isPathMatch, isRoot } from 'utilities';
import * as paths from 'paths';
import * as LayoutComponents from './Components';

const Routes: FC = () => {
  const isProtectedRoute = isPathMatch(paths.PROTECTED_ROUTES, window.location.pathname);
  const RedirectComponent = isProtectedRoute ? LayoutComponents.AuthLayout : ErrorPage;
  const client = useClient();

  function renderRootRoutes() {
    return (
      <Switch>
        <Route exact path={paths.index} component={LayoutComponents.AuthLayout} />
        <Route exact path={paths.unsubscribe} render={LayoutComponents.UnsubscribeLayout} />
        <Route render={() => <Redirect to={paths.index} />} />
      </Switch>
    );
  }

  function renderSubdomainRoutes() {
    return (
      <Switch>
        <Route exact path={paths.logout} render={renderLogoutRedirect} />
        <Route exact path={paths.index} component={LayoutComponents.AuthLayout} />
        <Route exact path={paths.invitation} component={LayoutComponents.AuthLayout} />
        <Route exact path={paths.login} component={LayoutComponents.AuthLayout} />
        <Route exact path={paths.signUp} component={LayoutComponents.AuthLayout} />
        <Route exact path={paths.forgotPassword} component={LayoutComponents.AuthLayout} />
        <Route
          exact
          path={paths.socialMediaPolicy}
          component={LayoutComponents.SocialMediaPolicyLayout}
        />
        <Route component={RedirectComponent} />
      </Switch>
    );
  }

  function renderLogoutRedirect(): Component {
    location.replace(`https://${client.subdomain}`);
    return null;
  }

  return isRoot() ? renderRootRoutes() : renderSubdomainRoutes();
};

export default Routes;
